var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Banners'),_c('HomeSummaryCards'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('ReferralLink'),_c('HomeExperiences'),_c('HomeReferrals')],1),_c('div',{staticClass:"col-12 col-lg-4"},[_c('HomeShortcuts'),_c('HomeVouchers'),_c('HomeSupport'),_c('HomeLatestClients')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }